/* eslint-disable import/prefer-default-export */
/**
 * Canonical Stock List Generator SKU columns: one checkbox column per main format.
 * Collision policy: when multiple SKUs match, pickSkuForColumn in mailchimpSkuColumnMap.js
 * applies stable sort — prefer validity_status === 'valid', then non-legacy, then lower key.
 */

function normCt(sku) {
  return String(sku.container_type ?? sku.containerType ?? '').toLowerCase();
}

/** Unit type without trailing bottle marker (e.g. 330b → 330). Keg sizes stay numeric strings. */
function normUnit(sku) {
  return String(sku.unit_type ?? sku.unitType ?? '').trim().replace(/b$/i, '');
}

function normPack(sku) {
  const p = String(sku.pack_type ?? sku.packType ?? '').trim();
  return p || '1';
}

function normCase(sku) {
  return String(sku.case_type ?? sku.caseType ?? '').trim().toLowerCase();
}

export const MAILCHIMP_SKU_COLUMNS = [
  {
    id: 'slab_24x330',
    label: '24 × 330ml',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '330') return false;
      if (normPack(sku) !== '1') return false;
      const c = normCase(sku);
      return c === '24x1' || c === '24x.330';
    },
  },
  {
    id: 'slab_4x6_330',
    label: '4 × 6 330ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '330') return false;
      if (normPack(sku) !== '6') return false;
      return normCase(sku) === '4x6';
    },
  },
  {
    id: 'slab_15x440',
    label: '15 × 440ml',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '440') return false;
      if (normPack(sku) !== '1') return false;
      const c = normCase(sku);
      return c === '15x1' || c === '15x.440';
    },
  },
  {
    id: 'slab_24x440',
    label: '24 × 440ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '440') return false;
      if (normPack(sku) !== '1') return false;
      const c = normCase(sku);
      return c === '24x1' || c === '24x.440';
    },
  },
  {
    id: 'slab_24x375',
    label: '24 × 375ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '375') return false;
      if (normPack(sku) !== '1') return false;
      const c = normCase(sku);
      return c === '24x1' || c === '24x.375';
    },
  },
  {
    id: 'slab_16x375',
    label: '16 × 375ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '375') return false;
      if (normPack(sku) !== '1') return false;
      const c = normCase(sku);
      return c === '16x1' || c === '16x.375';
    },
  },
  {
    id: 'slab_4x6_375',
    label: '4 × 6 375ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '375') return false;
      if (normPack(sku) !== '6') return false;
      return normCase(sku) === '4x6';
    },
  },
  {
    id: 'slab_6x4_375',
    label: '6 × 4 375ml cans',
    group: 'slab',
    match: (sku) => {
      if (normCt(sku) !== 'can') return false;
      if (normUnit(sku) !== '375') return false;
      if (normPack(sku) !== '4') return false;
      return normCase(sku) === '6x4';
    },
  },
  {
    id: 'keg_19_5l',
    label: '19.5L keg',
    group: 'keg',
    match: (sku) => normCt(sku) === 'keg' && normUnit(sku) === '19500',
  },
  {
    id: 'keg_30l',
    label: '30L keg',
    group: 'keg',
    match: (sku) => normCt(sku) === 'keg' && normUnit(sku) === '30000',
  },
  {
    id: 'keg_50l',
    label: '50L keg',
    group: 'keg',
    match: (sku) => normCt(sku) === 'keg' && normUnit(sku) === '50000',
  },
  {
    id: 'bottle_375',
    label: '375ml bottle',
    group: 'bottle',
    match: (sku) => normCt(sku) === 'bottle' && normUnit(sku) === '375',
  },
  {
    id: 'bottle_750',
    label: '750ml bottle',
    group: 'bottle',
    match: (sku) => normCt(sku) === 'bottle' && normUnit(sku) === '750',
  },
];
